import { TeamOutlined } from '@ant-design/icons';
import { Alert, Card } from 'antd';
import { OrgGroupPanel } from '@hq/org-admin';
import { hq } from '../session';

/**
 * 医共体 / 集团（`org_group`）：统招分签、集团采购的归口单位。
 * 机构在「机构管理」里通过「所属医共体」挂靠，成员机构共享牵头机构的合同与价格口径。
 */
export default function OrgGroups() {
  return (
    <Card
      className="page-card"
      title={
        <span>
          <TeamOutlined style={{ marginRight: 8 }} />
          医共体 / 集团
        </span>
      }
    >
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
        message="医共体 / 集团维护"
        description="先建医共体并指定牵头机构，再到「机构管理」把分院/社区医院挂靠进来。仍有机构挂靠时不允许删除医共体。"
      />
      <OrgGroupPanel hq={hq} />
    </Card>
  );
}
